/* Etiquetas multiidoma en inglés. */
export default {
  "qrExcursion.qrError.message": "Error reading the QR: {error}",
  "qrExcursion.qrError.title": "Error reading the QR",
  "qrExcursion.qrFormat.message": "The QR code does not match the specified format.",
  "qrExcursion.qrFormat.title": "Format error",
};
